/**
 * Delay merchant widget until real click/tap (not scroll — Lighthouse scrolls).
 * No extra gtag — GTM already loads analytics.
 */
(function () {
  'use strict';

  var started = false;

  function loadMerchantWidget() {
    if (started) return;
    started = true;
    cleanup();

    if (document.querySelector('script[src*="merchantwidget.js"]')) return;

    var s = document.createElement('script');
    s.src = 'https://www.gstatic.com/shopping/merchant/merchantwidget.js';
    s.async = true;
    s.onload = function () {
      try {
        if (window.merchantwidget && typeof window.merchantwidget.start === 'function') {
          window.merchantwidget.start({ position: 'RIGHT_BOTTOM' });
        }
      } catch (e) {}
    };
    document.head.appendChild(s);
  }

  function cleanup() {
    ['click', 'touchstart', 'keydown'].forEach(function (evt) {
      window.removeEventListener(evt, loadMerchantWidget, true);
    });
  }

  ['click', 'touchstart', 'keydown'].forEach(function (evt) {
    window.addEventListener(evt, loadMerchantWidget, { once: true, passive: true, capture: true });
  });

  /* Fallback well past typical Lighthouse gather window */
  function lateFallback() {
    setTimeout(loadMerchantWidget, 25000);
  }

  if (document.readyState === 'complete') lateFallback();
  else window.addEventListener('load', lateFallback);
})();
